import * as React from "react";

export const RewardsLoginIcon = () => {
  return (
    <div className="rewards-details-column">
      <section>
        <div className="div-reward-top-sign-image">
          <img className="reward-top-sign-image" alt="rewards" />
        </div>
      </section>
    </div>
  );
};
